import { call, put, retry, select, takeEvery } from '@redux-saga/core/effects'
import { AuthenticationApi } from '../../api/Authentication/AuthenticationApi'
import { SignInResult, SignUpResult } from '../../api/Authentication/types'
import { env } from '../../environment'
import { BOOT_RETRY_ATTEMPTS, BOOT_RETRY_DELAY } from '../boot'
import { addLoader } from '../loading/sagas'
import { LoaderName } from '../loading/types'
import { AuthenticationActions } from './actions'
import { apiTokenSelector, credentialsSelector } from './selectors'
import { AuthenticationActionTypes } from './types'

function* initializeUserSaga() {
  const credentials = yield select(credentialsSelector)
  if (credentials) {
    return
  }

  const { uuid, password }: SignUpResult = yield call(AuthenticationApi.signUp, env().clientUuid)
  yield put(AuthenticationActions.storeUserCredentials(uuid, password))
}

function* requestApiToken() {
  yield call(initializeUserSaga)
  const credentials = yield select(credentialsSelector)
  const { accessToken, tokenType, refreshToken }: SignInResult = yield call(AuthenticationApi.signIn, credentials)
  yield put(AuthenticationActions.storeApiToken(accessToken, tokenType, refreshToken))
}

export function* signIn() {
  const apiToken = yield select(apiTokenSelector)
  if (apiToken && apiToken.accessToken) {
    return
  }

  yield retry(BOOT_RETRY_ATTEMPTS, BOOT_RETRY_DELAY, requestApiToken)
}

export function* signInUserWatcher() {
  yield takeEvery(AuthenticationActionTypes.SIGN_IN_USER, addLoader(signIn, LoaderName.SIGN_IN_USER))
}
